// extracted by mini-css-extract-plugin
module.exports = {"facebookIcon":"_2Y0G3"};